import React from 'react';
import styles from 'Custom/Question/QuestionWrapper.module.scss';
import Container from 'Nori/Container/index';
import Question from './index';

const QUESTION_BACKGROUND = {
  blue: styles.blueBackground,
  default: styles.noBackground,
};

const QuestionWrapper = ({
  className = '',
  title = '',
  moduleNumber = '00',
  background = '',
  content = [],
  questions = [],
  ...props
}) => {
  const backgroundClassName =
    QUESTION_BACKGROUND[background] || QUESTION_BACKGROUND.default;

  return (
    <>
      <div
        className={`${styles.questionWrapper} ${backgroundClassName} ${className}`}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-module_name={title}
        data-design-module_no={moduleNumber}
        data-qa-tag="question-section-wrapper"
      >
        <Container data-qa-tag="question-section-container-box">
          {title && <h2 data-qa-tag="question-section-heading">{title}</h2>}
          <div
            className={styles.questionContainer}
            data-qa-tag="question-section-container"
          >
            {questions && <Question {...props} data-qa-tag="question-box" />}
            {content && (
              <div data-qa-tag="question-section-content">{content}</div>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

export default QuestionWrapper;
